exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected-proj[data-v-10f6fdc7]{box-shadow:0 0 10px 3px #4dc0b5}.sticky-top-cust[data-v-10f6fdc7]{position:-webkit-sticky;position:sticky;top:0;z-index:1000}", ""]);

// exports
